<template>
  <SimpleDataTable
      :title="title"
      :description="''"
      :dataList="salespersonSalePaymentDetailData"
      :dataHeaders="salespersonSalePaymentDetailHeaders"
      :loading="salespersonSalePaymentDetailDataLoading"
      :per-page="perPage"
      :pagination-status="true"
      :pagination-length="maxPage"
      @page-change="handlePageChange"
      :error-message="errorMessage"
  >
    <template v-slot:filterAndAction>

      <v-select
          v-model="timePeriodFilterValue"
          :items="[
                      {value: 5, text: 'Tarih Aralığı'},
                      {value: 4, text: 'Yıllık'},
                      {value: 3, text: 'Aylık'},
                      {value: 2, text: 'Haftalık'},
                      {value: 1, text: 'Günlük'}
                  ]"
          style="max-width: 250px; height: 30px; margin: 0 3px"
          label=""
          item-text="text"
          item-value="value"
          filled
          solo
          hide-details
          dense
          @change="timePeriodFilterValue !== 5  ? _fetchSalesPersonSalePaymentDetailList : null"
      >

      </v-select>
      <div v-if="timePeriodFilterValue === 5">
        <v-menu
            :close-on-content-click="false"
            :nudge-right="40"
            transition="scale-transition"
            offset-y
            min-width="auto"
        >
          <template v-slot:activator="{ on, attrs }">
            <v-text-field
                :value="formattedDate(dateRangeStartFilterValue)"
                placeholder="Filtre Başlangıç Tarihi"
                class="m-1"
                readonly
                filled
                solo
                dense
                clearable
                @click:clear="dateRangeStartFilterValue = null"
                hide-details
                v-bind="attrs"
                v-on="on"
            ></v-text-field>
          </template>
          <v-date-picker
              v-model="dateRangeStartFilterValue"
              locale="tr"
              :max="dateRangeEndFilterValue ? dateRangeEndFilterValue : 'NaN-Nan-Nan'"
          ></v-date-picker>
        </v-menu>
        <v-menu
            :close-on-content-click="false"
            :nudge-right="40"
            transition="scale-transition"
            offset-y
            min-width="auto"
        >
          <template v-slot:activator="{ on, attrs }">
            <v-text-field
                :value="formattedDate(dateRangeEndFilterValue)"
                placeholder="Filtre Bitiş Tarihi"
                readonly
                solo
                filled
                class="m-1"
                dense
                clearable
                @click:clear="dateRangeEndFilterValue = null"
                hide-details
                v-bind="attrs"
                v-on="on"
            ></v-text-field>
          </template>
          <v-date-picker
              v-model="dateRangeEndFilterValue"
              locale="tr"
              :min="dateRangeStartFilterValue"
          ></v-date-picker>
        </v-menu>
        <div class="w-100 text-center">
          <v-btn
              x-small
              class="mx-auto"
              color="primary darken-2"
              @click="_fetchSalesPersonSalePaymentDetailList"
          >
            FİLTRELE
          </v-btn>
        </div>

      </div>
    </template>
    <template v-slot:perPage>
      <p class="text-start m-0">Gösterilen Kayıt Sayısı</p>
      <v-btn-toggle class="my-4 p-0" mandatory solo dense>
        <v-btn @click="perPage = 10"> 10</v-btn>
        <v-btn @click="perPage = 20"> 20</v-btn>
        <v-btn @click="perPage = 30"> 30</v-btn>
        <v-btn @click="perPage = 50"> 50</v-btn>
        <v-btn @click="perPage = 100"> 100</v-btn>
      </v-btn-toggle>
    </template>

<!--    <template v-slot:pagination>-->
<!--      <div class="row">-->
<!--        <div class="col-lg-12 mb-5">-->
<!--          <v-pagination-->
<!--              v-model="currentPage"-->
<!--              class="my-4"-->
<!--              :length="1"-->
<!--              :total-visible="8"-->
<!--          ></v-pagination>-->
<!--        </div>-->
<!--      </div>-->
<!--    </template>-->
  </SimpleDataTable>
</template>

<script>

import SimpleDataTable from "@/components/dashboard/SimpleDataTable";
import {formattedDate} from "@/momentHelper";
import {numberConverter} from "../../../../helpers";
import {mapActions, mapState} from "vuex"

export default {
  name: "PlasiyerTahsilatAnalizDetay",
  components: {
    SimpleDataTable
  },
  props:{
    dashboardFilterCurrentCodeProp: {
      type: String,
      default: null
    },
    dashboardFilterSalesPersonCodeProp: {
      type: String,
      default: null
    },
    dashboardFilterReportDbNameProp: {
      type: String,
      default: null
    },
    title: {
      type: String,
      default: ""
    }
  },
  computed: {
    ...mapState("auth",["user"])
  },
  mounted(){
    this._fetchSalesPersonSalePaymentDetailList()
  },
  data(){
    return {
      salespersonSalePaymentDetailHeaders:[],
      salespersonSalePaymentDetailData:[],
      salespersonSalePaymentDetailDataLoading: false,
      timePeriodFilterValue: 4,
      dateRangeStartFilterValue: null,
      dateRangeEndFilterValue: null,
      currentPage:1,
      perPage:10,
      maxPage: null,
      searchTextSalesPersonCode: null,
      errorMessage: "",

    }
  },
  methods: {
    ...mapActions("dashboard",["fetchSalesPersonSalePaymentDetailList"]),
    formattedDate,
    numberConverter,
    async handlePageChange(newPage) {
      this.currentPage = newPage;
      await this._fetchSalesPersonSalePaymentDetailList();
    },
    getTypeName(item){
      if (item===1){
        return 'Nakit';
      }else if (item===2){
        return 'Senet';
      }else if (item===3){
        return 'Çek';
      }else{
        return 'Dekont';
      }
    },
    _fetchSalesPersonSalePaymentDetailList(){

      this.salespersonSalePaymentDetailDataLoading = true;
      const requestData = {
        params: {
          userId: this.user.UserId,
          pageNumber: this.currentPage,
          pageSize: this.perPage,
        },
        body: {
          ...(!(this.dashboardFilterCurrentCodeProp === "" || this.dashboardFilterCurrentCodeProp == null)) && {currentCode: this.dashboardFilterCurrentCodeProp},
          ...(!(this.dashboardFilterSalesPersonCodeProp === "" || this.dashboardFilterSalesPersonCodeProp == null)) && {salesPersonCode: this.dashboardFilterSalesPersonCodeProp},
          ...(!(this.dashboardFilterReportDbNameProp === "" || this.dashboardFilterReportDbNameProp == null)) && {reportDbName: this.dashboardFilterReportDbNameProp},
          ...(!(this.timePeriodFilterValue === "" || this.timePeriodFilterValue == null)) && {DateType: this.timePeriodFilterValue},
          ...(!(this.searchTextSalesPersonCode === "" || this.searchTextSalesPersonCode == null)) && {salesPersonCode: this.searchTextSalesPersonCode}
        }
      };
      if (this.timePeriodFilterValue === 5) {
        requestData.body.startDate = this.dateRangeStartFilterValue;
        requestData.body.endDate = this.dateRangeEndFilterValue;
      }
      this.fetchSalesPersonSalePaymentDetailList(requestData).then((result) => {
        if(result && result.data.success)
        {
          this.salespersonSalePaymentDetailData = result.data.data;
          this.salespersonSalePaymentDetailData.forEach((elem) => {
            elem.type=this.getTypeName(elem.type);
            elem.date=this.formattedDate(elem.date, "DD-MM-YYYY");
            elem.credit=this.numberConverter(elem.credit);
          });
          this.salespersonSalePaymentDetailHeaders = [
            {
              key: 'date',
              label: 'Tarih',
              sortable: false,
            },
            {
              key: 'currentCode',
              label: 'Cari Kodu',
              sortable: false,
            },
            {
              key: 'currentName',
              label: 'Cari Adı',
              sortable: false,
            },
            {
              key: 'description',
              label: 'Açıklama',
              sortable: false,
            },
            {
              key: 'salesPersonCode',
              label: 'Plasiyer Kodu',
              sortable: false,
            },
            {
              key: 'salesPersonName',
              label: 'Plasiyer Adı',
              sortable: false,
            },
            {
              key: 'credit',
              label: 'Alacak',
              sortable: false,
            },
            {
              key: 'type',
              label: 'Tip',
              sortable: false,
            }

          ]
          this.maxPage = result.data.totalPages;
        }
        else {
          this.errorMessage = result.data.message;
          this.salespersonSalePaymentDetailData = [];
        }

        this.salespersonSalePaymentDetailDataLoading = false;
      })
    }
  },
  watch: {
    perPage: function(newVal){
      newVal;
      this.currentPage = 1;
      this._fetchSalesPersonSalePaymentDetailList()
    },
    dashboardFilterCurrentCodeProp(newVal){
      newVal;
      this._fetchSalesPersonSalePaymentDetailList()
    },
    dashboardFilterSalesPersonCodeProp(newVal){
      newVal;
      this._fetchSalesPersonSalePaymentDetailList()
    },
    dashboardFilterReportDbNameProp(newVal){
      newVal;
      this._fetchSalesPersonSalePaymentDetailList()
    },
    timePeriodFilterValue(newVal){
      newVal;
      this._fetchSalesPersonSalePaymentDetailList()
    },
  }
}
</script>

<style scoped>

</style>